import {
    Box,
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem
} from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { CommonSelect } from '../../../component/select';
import AnimateButton from '../../../component/extended/AnimateButton';
import { updateClinic } from '../../../store/userReducer';
import { useClinic } from '../../../utils/ClinicContext';
import { getMedicalRoles, getUniqueClinics } from '../../../utils/accessSelection';

function SelectClinic({ ...others }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);
    const { setClinic } = useClinic();
    const clinics = useMemo(
        () => getUniqueClinics(getMedicalRoles(user.roles)),
        [user.roles]
    );

    useEffect(() => {
        if (!user.uuid) navigate('/', { replace: true });
    }, [navigate, user.uuid]);

    const formik = useFormik({
        initialValues: { clinicUuid: '' },
        validate: ({ clinicUuid }) =>
            clinics.some((clinic) => clinic.uuid === clinicUuid)
                ? {}
                : { clinicUuid: 'Selecione uma clínica.' },
        onSubmit: ({ clinicUuid }, { setSubmitting }) => {
            const clinic = clinics.find((candidate) => candidate.uuid === clinicUuid);
            if (!clinic) {
                setSubmitting(false);
                return;
            }

            dispatch(updateClinic(clinic));
            setClinic(clinic);
            sessionStorage.setItem('clinic', JSON.stringify(clinic));
            sessionStorage.removeItem('role');
            navigate('/', { replace: true });
        }
    });

    return (
        <form noValidate onSubmit={formik.handleSubmit} {...others}>
            <FormControl fullWidth error={Boolean(formik.errors.clinicUuid)}>
                <InputLabel id="clinicUuid-label">CLÍNICA</InputLabel>
                <CommonSelect
                    id="clinicUuid-label"
                    name="clinicUuid"
                    label="CLÍNICA"
                    value={formik.values.clinicUuid}
                    onChange={formik.handleChange}
                    renderValue={(value) =>
                        clinics.find((clinic) => clinic.uuid === value)?.name || ''
                    }
                >
                    {clinics.map(({ uuid, name }) => (
                        <MenuItem key={uuid} value={uuid}>
                            {name}
                        </MenuItem>
                    ))}
                </CommonSelect>
                {formik.errors.clinicUuid && (
                    <FormHelperText>{formik.errors.clinicUuid}</FormHelperText>
                )}
            </FormControl>
            <Box sx={{ mt: 2 }}>
                <AnimateButton>
                    <Button
                        disableElevation
                        disabled={formik.isSubmitting || clinics.length === 0}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        color="secondary"
                    >
                        Selecionar
                    </Button>
                </AnimateButton>
            </Box>
        </form>
    );
}

export default SelectClinic;
